import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import axios from "axios";
import TopBar from "../../components/TopBar/TopBar";
import { LayoutPage } from "../../components/Layout/layoutPage";
import TabsCustom from "../../components/Tabs/Tabs";
import ConditionsForm from "../../components/Formik/ConditionForm";
import { importBaseActions } from "../../store/reducers/base";
import { getProductName } from "../../Utility";
import { RegionsApi } from "../../v2/api/regions_api";
import Loading from "../../components/Loading/loading";
import ErrorCustom from "../../components/Error/Error";
import { mapConfigurationToFormik } from "../../components/Formik/mapFormik";
import { useDialogs } from "../../v2/providers/dialogs_provider";
import DeleteConfigurationButton from "../../components/Layout/DeleteButton";
import { CategoryCode } from "../../v2/models/category";

const Richiesta = () => {
  const count = useSelector((state) => state.base);
  const baseActions = importBaseActions();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const dialogs = useDialogs();
  const [refresh, setRefresh] = useState(false);
  const classes = useStyles();


  const [regions, setRegions] = useState({ provinces: [], cities: [] });
  const [data, setData] = useState({
    state: "loading",
    steps: [],
    currentStep: null,
    quote: null,
    customer: null,
    discountError: null,
    errors: {},
  });
  const [isServiceCustomer, setIsServiceCustomer] = useState("");

  const axiosConfig = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${count.user.token}`,
    },
  };

  const load = async () => {
    let steps = [];
    let currentStep = null;
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/categories-steps`,
        { id: count.idPorta, quote_id: count.quoteId },
        axiosConfig
      );
      if (res.data?.data) {
        steps = res.data.data;
        currentStep = steps.find((cs) => `/${cs.slug}` === location.pathname);
      }
    } catch {}

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/richiesta-form?v=2`,
        { id: count.quoteId },
        axiosConfig
      );
      if (res.data.success === 1) {
        const quote = res.data.data.quote;
        const customer = res.data.data.customer;
        const endClientSummary = quote ? JSON.parse(quote.end_client_summary) : null;

        setIsServiceCustomer(customer.is_service_customer);

        setData({
          state: "idle",
          steps,
          currentStep,
          quote,
          customer,
          endClientSummary,
        });
      }
    } catch (e) {
      setData({ state: "error", error: e });
    }
  };

  const applyDiscount = async (values,Actualformik) => {
    try {
      setRefresh(true)
      let res = await axios.post(
        `${process.env.REACT_APP_API_URL}/update-discount`,
        {
          quoteId: count.quoteId,
          discount1: values.retailDiscount1,
          discount2: values.retailDiscount2,
          discount3: 0,
          taxRate: values.retailTaxRate,
          endClientDiscount1: values.endClientDiscount1,
          endClientDiscount2: values.endClientDiscount2,
          endClientTaxRate: values.endClientTaxRate,
          depositType: values.retailDownPaymentType,
          depositValue: values.retailDownPaymentValue,
          retailInstallation: values.retailInstallation,
          retailTransport: values.retailTransport,
          customClientName: values.customClientName,
          customClientAddress: values.customClientAddress,
          customClientCity: values.customClientCity,
          customClientProvince: values.customClientProvince,
          customClientZipCode: values.customClientZipCode,
          customClientCountry: values.customClientCountry,
          packagingType: values.packagingType
        },
        axiosConfig
      );
      console.log(res)
      if (res.data.success === 1) {
        const updatedConfig = res.data.data?.configuration;

        const mappedValues = mapConfigurationToFormik(updatedConfig);

        Actualformik.setValues({
          ...mappedValues,
          isServiceCustomer: values.isServiceCustomer,
          endClientDownPaymentValue: values.endClientDownPaymentValue,
          endClientDownPaymentType: values.endClientDownPaymentType,
          retailDownPaymentType: values.retailDownPaymentType,
          retailDownPaymentValue: values.retailDownPaymentValue,
          notes: Actualformik.values.notes,
          packagingType: values.packagingType
        });
      }else{
        console.log("ERRORE")
        setRefresh(true);
        const e = res.data.message;
        dialogs?.showError("Attenzione...", e);
      }
       setRefresh(false);
    } catch (e){
      setRefresh(true);

      if (typeof e == "string") {
        dialogs?.showError("Attenzione...", e);
      } else {
        if (e.severity == "error") {
          dialogs?.showError("Attenzione...", e.message);
        } else if (e.severity == "warning") {
          dialogs?.showWarning("Attenzione...", e.message);
        }
      }
    }
  };
  const saveRichiesta = async (values, Actualformik) => {
    try {
      setRefresh(true);
      await applyDiscount(values,Actualformik);
      let res = await axios.post(`${process.env.REACT_APP_API_URL}/richiesta`,
        {
          quoteId: count.quoteId,
          customClientName: values.customClientName,
          customClientAddress: values.customClientAddress,
          customClientCity: values.customClientCity,
          customClientProvince: values.customClientProvince,
          customClientZipCode: values.customClientZipCode,
          customClientCountry: values.customClientCountry,
          endClientDepositType: values.endClientDepositType,
          endClientDepositValue: values.endClientDepositValue,
          endClientTaxRate: values.endClientTaxRate,
          depositType: values.retailDownPaymentType,
          depositValue: values.retailDownPaymentValue,
          discount1: values.retailDiscount1,
          discount2: values.retailDiscount2,
          taxRate: values.retailTaxRate,
          endClientDiscount1: values.endClientDiscount1,
          endClientDiscount2: values.endClientDiscount2,
          retailInstallation: values.retailInstallation,
          retailTransport: values.retailTransport,
          notes: Actualformik.values.notes,
          packagingType: Actualformik.values.notes
        },
        axiosConfig
      );

      if (res.data.success === 1) {
        dispatch(baseActions.setRichiesta(true));
        navigate(`/generaPDF`);
      } else {
        dialogs?.showError("Errore salvataggio", res.data.message);
      }

      setRefresh(false);
    } catch (e) {
      console.log(e);
      setData({ ...data, state: "idle" });
      setRefresh(false);

      if (typeof e === "string") {
        dialogs?.showError("Attenzione...", e);
      } else {
        if (e.severity === "error") {
          dialogs?.showError("Attenzione...", e.message);
        } else if (e.severity === "warning") {
          dialogs?.showWarning("Attenzione...", e.message);
        }
      }
    }
  };

  useEffect(() => {
    load();
  }, []);

  if (data.state === "error") return <ErrorCustom message={data.error} route="dimensioni" />;
  if (data.state === "loading") return <Loading />;

  return (
  <LayoutPage>
   <div style={{ flex: "0 0 auto" }}>
        <TopBar />

        <div className={"d-flex justify-content-between p-3 title-configuration-main"}>
          <div className="d-flex flex-column" style={{ lineHeight: "1" }}>
            <h2 className="h2 fw-bold">
              Nuova configurazione {getProductName(count.idPorta)} (#{count.quoteId})
            </h2>
          </div>
          <div className={"d-flex justify-content-between align-items-center"}>
            {/* <Button variant={deleteClickCount == 0 ? "outlined" : "contained"} color="error" className="me-3 px-2">
                  <RemoveCircleOutlineOutlinedIcon />
                  <span className="ms-2">{deleteClickCount == 0 ? "ELIMINA" : "CONFERMA"}</span>
              </Button> */}
            <DeleteConfigurationButton 
              quoteId ={count.quoteId}
              currentUser={count.user}
            />
            <Button variant="contained" color="secondary" onClick={() => navigate("/configurations")}>
              <CloseIcon />
              <span className="ms-2">CHIUDI</span>
            </Button>
          </div>
        </div>

        <Grid className={classes.root} container sx={{ justifyContent: "center" }} display={{ xs: "none", sm: "none", md: "flex" }}>
          {data.currentStep && (
            <TabsCustom
              value={data.currentStep.id}
              id={count.idPorta}
              count={count}
              axios_conf={axiosConfig}
              url={`${process.env.REACT_APP_API_URL}/categories-steps`}
            />
          )}
        </Grid>
      </div>
      <div style={{ flex: "1 1 auto", minHeight: "0" }}>
        <div className="container h-full">
          {!data.quote && (
            <div className="row mt-3">
              <div className="col-12">
                <div className="alert alert-danger">
                  <strong>Attenzione!</strong> Configurazione non valida
                </div>
              </div>
            </div>
          )}
          {data.quote && (
            <ConditionsForm
              currentUser={count.user}
              quote_id = {count.quoteId}
              category = {CategoryCode.PortaOverlap}
              applyDiscount={applyDiscount}
              handlingSubmit={saveRichiesta}
              goBack="/accessori"
            />
          )}
        </div>
      </div>
      {refresh && <div className="d-flex align-items-center justify-content-center" style={{
        position: "absolute", height: "100%", width: "100%", top: "0", left: "0",
        backgroundColor: "rgba(255,255,255,0.5)"
      }}>
        <CircularProgress />
      </div>}
    </LayoutPage>
  );
};

const useStyles = makeStyles({
  root: {
    "& .MuiTabs-flexContainer": {
      justifyContent: "center",
    },
  },
});

export const AmountItem = ({ label, value }) => (
  <>
    <h6 className="h6">{label}</h6>
    <h6 className="h6 text-primary">
      {Number(value)
        .toFixed(2)
        .replace(".", ",")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")} &euro;
    </h6>
  </>
);

export const NumberItem = ({ label, value, decimal = 0 }) => (
  <>
    <h6 className="h6">{label}</h6>
    <h6 className="h6 text-primary">
      {Number(value).toFixed(decimal)}
    </h6>
  </>
);

export default Richiesta;